import { type TransactionStatus } from "@/types/transaction";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface TransactionStatusBadgeProps {
  status: TransactionStatus;
  className?: string;
}

export function TransactionStatusBadge({ status, className }: TransactionStatusBadgeProps) {
  const config = {
    outstanding: {
      label: "Outstanding",
      variant: "secondary" as const,
      className: "border-blue-500 text-blue-700 dark:text-blue-300",
    },
    completed: {
      label: "Completed",
      variant: "outline" as const,
      className: "border-green-500 text-green-700 dark:text-green-300",
    },
    overdue: {
      label: "Overdue",
      variant: "destructive" as const,
      className: "",
    },
  };

  const { label, variant, className: statusClassName } = config[status];

  return (
    <Badge variant={variant} className={cn(statusClassName, className)}>
      {label}
    </Badge>
  );
}
